import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-internal-selection',
  templateUrl: './banner-internal-selection.component.html',
  styleUrls: ['./banner-internal-selection.component.scss']
})
export class BannerInternalSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
